import { html, LitElement } from 'lit';
import { ifDefined } from 'lit-html/directives/if-defined.js';
import { forms } from '../styles/forms.style.js';
import { style } from './text-field.style.js';
import '@cof/fs-text-field-wc/fs-text-field.js';
import '../../../polyfills.js';

class TextField extends LitElement {
  static get properties() {
    return {
      errMessage: { type: String },
      focus: { type: Boolean, attribute: true },
      name: { type: String, attribute: true },
      label: { type: String, attribute: true },
      type: { type: String, attribute: true },
      pattern: { type: Object, attribute: true },
      helper: { type: String, attribute: true },
      checkbox: { type: Object, attribute: true },
    };
  }

  static get styles() {
    return [forms, style];
  }

  render() {
    return html`
      <fs-text-field
        type="${this.type}"
        .value="${this.value ? this.value : ''}"
        id="${this.label.toCamelCase()}"
        pattern-mismatch-message="${this.pattern?.errorMessage}"
        helper-text="${this.helper ? this.helper : ''}"
        required
        .pattern=${ifDefined(this.pattern?.rule)}
      >
        ${this.label}
      </fs-text-field>
    `;
  }

  firstUpdated() {
    this.input = this.shadowRoot.querySelector('fs-text-field');
    if (this.focus) {
      this.input.focus();
    }
  }
}

customElements.define('text-field', TextField);
